import React, { useEffect, useState } from 'react';
import { Link, NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';
import logo from '../assets/logo.svg';
import { AiOutlineMenu, AiOutlineClose } from "react-icons/ai";
import { logout } from '../utils/logout';
import { useAuthContext } from '../context/Auth';
import { getProfileLabel } from '../utils/profileLabel';

const DashboardLayout = () => {

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { userInfos, isLoading } = useAuthContext();

  const location = useLocation();
  const navigate = useNavigate();

  const menuItems = [
    { to: '/dash', label: 'Dashboard', profile: ['company','receiver'] },
    { to: '/receivers', label: 'Recebedores', profile: ['company'] },
    { to: '/billets', label: 'Boletos', profile: ['company'] },
    { to: '/account', label: 'Conta', profile: ['company','receiver'] },
  ];

  useEffect(() => {
    if(!localStorage.getItem('token')){
      window.location.href = '/';
    }
  })

  useEffect(() => {
    if (!userInfos?.profile || isLoading) return;

    const allowedRoutes = menuItems
      .filter(item => item.profile.includes(userInfos.profile))
      .map(item => item.to);

    const currentPath = location.pathname;

    // Se a rota atual não for permitida, redireciona
    if (!allowedRoutes.includes(currentPath)) {
      navigate('/dash');
    }
  }, [userInfos, location.pathname, isLoading]);

  return (
    <div className="flex min-h-screen">
      {/* Sidebar - Desktop sempre visível, Mobile com toggle */}
      <div 
        className={`h-screen w-64 bg-gray-200 text-gray-800 p-6 fixed inset-y-0 left-0 transform z-10
        ${isMenuOpen ? 'translate-x-0' : '-translate-x-full'} transition-transform md:translate-x-0 md:relative overflow-y-auto shadow-lg`}
      >
        <div className="flex items-center justify-between md:block">
          <Link to="/dash">
            <img src={logo} alt="LucroTech" className="w-24 md:w-32 mb-8" />
          </Link>
          {/* Botão de fechar no Mobile */}
          <button className="md:hidden text-gray-800 flex items-center" onClick={() => setIsMenuOpen(false)}>
            <AiOutlineClose />
          </button>
        </div>
        {userInfos?.profile && (
          <div className="bg-blue-600 text-white text-sm font-medium px-3 py-1 rounded mb-4 w-fit shadow">
            {getProfileLabel(userInfos?.profile)}
          </div>
        )}
        {/* Menu */}
        <ul>
          {menuItems.filter(({ profile, label }) => {
            if (!userInfos?.profile) return label === 'Dashboard';
            return profile.includes(userInfos.profile);
          })
          .map(({ to, label }) => (
            <li key={to}>
              <NavLink 
                to={to} 
                className={({ isActive }) => 
                  isActive 
                    ? 'block text-blue-600 font-bold py-2' 
                    : 'block text-gray-700 hover:text-blue-600 py-2'
                }
                onClick={() => {
                  setIsMenuOpen(false);
                }}
              >
                {label}
              </NavLink>
            </li>
          ))}
          <li>
            <NavLink 
              className='block text-gray-700 hover:text-blue-600 py-2 cursor-pointer'
              onClick={() => {
                logout();
              }}
            >
              Sair
            </NavLink>
          </li>
        </ul>
      </div>

      {/* Conteúdo principal com rolagem */}
      <div className="flex-1 flex flex-col h-screen overflow-y-auto p-6">
        {/* Navbar no topo para mobile */}
        <div className="flex items-center justify-between md:hidden border-b pb-6">
          <Link to="/dash">
            <img src={logo} alt="LucroTech" className="w-24" />
          </Link>
          <button className="text-gray-600 text-32" onClick={() => setIsMenuOpen(true)}>
            <AiOutlineMenu />
          </button>
        </div>
        <Outlet />
      </div>
    </div>
  );
};

export default DashboardLayout;
